module.exports = __webpack_public_path__ + "assets/img/Best-Online-Trading-Services.54416ff1.png";